import { render, staticRenderFns } from "./shipout-request-done.vue?vue&type=template&id=681deb96&scoped=true"
import script from "./shipout-request-done.vue?vue&type=script&lang=js"
export * from "./shipout-request-done.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681deb96",
  null
  
)

export default component.exports